var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogosWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.00307 23.2187C1.00196 27.1677 2.04184 31.0235 4.01914 34.422L0.813965 46.034L12.7902 42.9181C16.1026 44.7074 19.814 45.6449 23.5855 45.6452H23.5954C36.0458 45.6452 46.1807 35.5925 46.186 23.2364C46.1884 17.249 43.8406 11.6188 39.575 7.38302C35.3101 3.14755 29.638 0.813768 23.5945 0.811035C11.1426 0.811035 1.00839 10.8632 1.00325 23.2187",
    fill: "url(#paint0_linear_33_306)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.196445 23.2114C0.19516 27.3024 1.2723 31.2962 3.32011 34.8164L0 46.8446L12.4056 43.6171C15.8238 45.4663 19.6723 46.4413 23.5883 46.4427H23.5984C36.4955 46.4427 46.9945 36.0284 47 23.23C47.0022 17.0275 44.57 11.1949 40.152 6.80735C35.7334 2.42032 29.8584 0.00255039 23.5984 0C10.6991 0 0.201586 10.4129 0.196445 23.2114ZM7.58444 34.2102L7.12123 33.4806C5.17404 30.4085 4.14628 26.8583 4.14775 23.2129C4.15179 12.5751 12.8769 3.92031 23.6058 3.92031C28.8015 3.9225 33.6843 5.9322 37.3569 9.57853C41.0293 13.2252 43.0502 18.0728 43.0489 23.2286C43.0441 33.8664 34.3188 42.5223 23.5984 42.5223H23.5907C20.1 42.5204 16.6766 41.5903 13.691 39.8325L12.9804 39.4144L5.6187 41.3296L7.58444 34.2102Z",
    fill: "url(#paint1_linear_33_306)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7496 13.5077C17.3115 12.5416 16.8505 12.5221 16.434 12.5052C16.0928 12.4906 15.7029 12.4917 15.3133 12.4917C14.9233 12.4917 14.2898 12.6373 13.7542 13.2175C13.2181 13.7982 11.7075 15.2017 11.7075 18.0561C11.7075 20.9105 13.8029 23.6693 14.095 24.0568C14.3874 24.4436 18.1401 30.4887 24.0834 32.8143C29.0228 34.7469 30.028 34.3626 31.1 34.2656C32.1722 34.1691 34.5596 32.8626 35.0467 31.5078C35.5341 30.1532 35.5341 28.992 35.388 28.7493C35.2419 28.5076 34.8519 28.3624 34.2672 28.0724C33.6824 27.7824 30.8075 26.3786 30.2716 26.1849C29.7355 25.9915 29.3457 25.8949 28.9558 26.4759C28.5658 27.0559 27.4461 28.3624 27.1048 28.7493C26.7639 29.1372 26.4226 29.1855 25.838 28.8953C25.2529 28.6042 23.3698 27.9922 21.1356 26.0159C19.3973 24.478 18.2238 22.5789 17.8827 21.9979C17.5416 21.4179 17.8462 21.1035 18.1394 20.8144C18.4021 20.5544 18.7243 20.1369 19.0169 19.7982C19.3085 19.4594 19.4058 19.2176 19.6008 18.8307C19.7959 18.4434 19.6983 18.1046 19.5523 17.8144C19.4058 17.5242 18.2695 14.6548 17.7496 13.5077Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_306",
    x1: 2269.42,
    y1: 4523.1,
    x2: 2269.42,
    y2: 0.811035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33_306",
    x1: 2350,
    y1: 4684.46,
    x2: 2350,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosWhatsapp);
export default __webpack_public_path__ + "static/media/logos_whatsapp.1d36e4f5644dff504c1b707346a6f7fc.svg";
export { ForwardRef as ReactComponent };